import { useEffect, useRef, useState } from 'react'
import { Search } from 'lucide-react'
import { useDebouncedValue } from '../../hooks/useDebouncedValue'

interface FilterBarProps {
  onChange: (query: string) => void
  placeholder?: string
  /** Debounce window (default 250ms — under the 300ms charter budget). */
  debounceMs?: number
}

/**
 * List-report search/filter (UX charter R1). Debounced so filtering fires under
 * 300ms after typing stops, not on every keystroke.
 */
export function FilterBar({ onChange, placeholder, debounceMs = 250 }: FilterBarProps) {
  const [text, setText] = useState('')
  const debounced = useDebouncedValue(text, debounceMs)
  const onChangeRef = useRef(onChange)
  onChangeRef.current = onChange

  useEffect(() => {
    onChangeRef.current(debounced)
  }, [debounced])

  return (
    <div className="flex items-center gap-2 rounded border border-neutral-300 px-3 py-2 dark:border-neutral-700">
      <Search size={16} className="text-neutral-400" />
      <input
        type="search"
        value={text}
        placeholder={placeholder}
        onChange={(e) => setText(e.target.value)}
        className="w-full bg-transparent text-sm outline-none"
        aria-label={placeholder ?? 'filter'}
      />
    </div>
  )
}
